// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aLs1G2 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0;
}

.VvGrvH {
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.lvJFtJ {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

.kg84nS {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
  text-align: left;
  width: 100%;
}

.IB7vlw {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mUe1oY {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  border-radius: var(--radius-xs);
  background-color: var(--surface-neutral-pale);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all var(--transition-normal);
  box-sizing: border-box;
}

.mUe1oY:focus {
  outline: 2px solid var(--brand-tr-orange);
  outline-offset: 2px;
}

.mUe1oY:focus:not(:focus-visible) {
  outline: none;
}

.mUe1oY:hover {
  background-color: var(--surface-neutral-light);
}

.mUe1oY.rocb3G {
  background-color: #ffeee5;
  border-color: var(--brand-tr-orange);
}

.mUe1oY.KPkaNw {
  cursor: not-allowed;
}

.mUe1oY.KPkaNw:hover {
  background-color: var(--surface-neutral-pale);
}

.dpJm1p {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.LAgnnk {
  width: 16px;
  height: 16px;
  border: 1px solid var(--text-neutral-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-normal);
}

.ZBFkD5 {
  border-color: var(--brand-tr-orange);
  background-color: var(--brand-tr-orange);
}

.fpjL0J {
  border-color: #cccccc;
  background-color: #fafafa;
}

.iLrCKu {
  width: 6px;
  height: 6px;
  background-color: var(--surface-neutral-white);
  border-radius: 50%;
}

.AAUHjI {
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
}

.w0Pgka {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.PWAdeS {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.nqTKDY {
  color: var(--text-neutral-dark);
}

.p22NWR {
  display: flex;
  align-items: flex-start;
}

.jRsOXd {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.zXYN2e {
  color: #387c2b;
}

.U7are0 {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--spacing-4);
}

.lXiGQh {
  font-family: var(--font-family-base);
  font-size: var(--type-caption-sm-font-size);
  color: var(--text-neutral-silver);
}

@media (max-width: 768px) {
  .mUe1oY {
    padding: var(--spacing-3);
  }

  .jRsOXd {
    padding-left: var(--spacing-6);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyTypeSelector/PixKeyTypeSelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,6CAA6C;EAC7C,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  padding: 0;\n}\n\n.fieldset {\n  border: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.hiddenRadio {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  width: 100%;\n}\n\n.optionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-xs);\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  box-sizing: border-box;\n}\n\n.option:focus {\n  outline: 2px solid var(--brand-tr-orange);\n  outline-offset: 2px;\n}\n\n.option:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.option:hover {\n  background-color: var(--surface-neutral-light);\n}\n\n.option.selected {\n  background-color: #ffeee5;\n  border-color: var(--brand-tr-orange);\n}\n\n.option.disabled {\n  cursor: not-allowed;\n}\n\n.option.disabled:hover {\n  background-color: var(--surface-neutral-pale);\n}\n\n.radioContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.radio {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--text-neutral-dark);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-normal);\n}\n\n.radioSelected {\n  border-color: var(--brand-tr-orange);\n  background-color: var(--brand-tr-orange);\n}\n\n.radioDisabled {\n  border-color: #cccccc;\n  background-color: #fafafa;\n}\n\n.radioDot {\n  width: 6px;\n  height: 6px;\n  background-color: var(--surface-neutral-white);\n  border-radius: 50%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  text-align: left;\n}\n\n.labelContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.labelDisabled {\n  color: var(--text-neutral-dark);\n}\n\n.descriptionContainer {\n  display: flex;\n  align-items: flex-start;\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.descriptionDisabled {\n  color: #387c2b;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: var(--spacing-4);\n}\n\n.canProceedIndicator {\n  font-family: var(--font-family-base);\n  font-size: var(--type-caption-sm-font-size);\n  color: var(--text-neutral-silver);\n}\n\n@media (max-width: 768px) {\n  .option {\n    padding: var(--spacing-3);\n  }\n\n  .description {\n    padding-left: var(--spacing-6);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `aLs1G2`,
	"fieldset": `VvGrvH`,
	"hiddenRadio": `lvJFtJ`,
	"title": `kg84nS`,
	"optionsContainer": `IB7vlw`,
	"option": `mUe1oY`,
	"selected": `rocb3G`,
	"disabled": `KPkaNw`,
	"radioContainer": `dpJm1p`,
	"radio": `LAgnnk`,
	"radioSelected": `ZBFkD5`,
	"radioDisabled": `fpjL0J`,
	"radioDot": `iLrCKu`,
	"content": `AAUHjI`,
	"labelContainer": `w0Pgka`,
	"label": `PWAdeS`,
	"labelDisabled": `nqTKDY`,
	"descriptionContainer": `p22NWR`,
	"description": `jRsOXd`,
	"descriptionDisabled": `zXYN2e`,
	"footer": `U7are0`,
	"canProceedIndicator": `lXiGQh`
};
module.exports = ___CSS_LOADER_EXPORT___;
